"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMenuGroup_unstable", {
    enumerable: true,
    get: ()=>useMenuGroup_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
function useMenuGroup_unstable(props, ref) {
    const headerId = (0, _reactUtilities.useId)('menu-group');
    return {
        components: {
            root: 'div'
        },
        root: (0, _reactUtilities.getNativeElementProps)('div', {
            ref,
            'aria-labelledby': headerId,
            role: 'group',
            ...props
        }),
        headerId
    };
} //# sourceMappingURL=useMenuGroup.js.map

//# sourceMappingURL=useMenuGroup.js.map